export default class WorkplaceSafetyCalculator {
  constructor() {
    this.form = document.getElementById('calculator-form');
    this.annualCostInput = document.getElementById('annual-cost');
    this.challengesInput = document.getElementById('challenges');
    this.recognitionsInput = document.getElementById('recognitions');
    this.challengeReductionInput = document.getElementById('challenge-reduction');
    this.recognitionReductionInput = document.getElementById('recognition-reduction');
    this.savingsAmount = document.getElementById('savings-amount');
    this.savingsText = document.getElementById('savings-text');

    this.bindEvents();
    this.calculateSavings();
  }

  bindEvents() {
    [
      this.annualCostInput,
      this.challengesInput,
      this.recognitionsInput,
      this.challengeReductionInput,
      this.recognitionReductionInput
    ].forEach(input => {
      input.addEventListener('input', () => this.calculateSavings());
    });
  }

  formatCurrency(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  }

  calculateSavings() {
    const annualCost = parseFloat(this.annualCostInput.value) || 0;
    const challenges = parseFloat(this.challengesInput.value) || 0;
    const recognitions = parseFloat(this.recognitionsInput.value) || 0;
    const challengeReductionPercent = parseFloat(this.challengeReductionInput.value) || 0;
    const recognitionReductionPercent = parseFloat(this.recognitionReductionInput.value) || 0;

    // Calculate reduction percentages
    const challengeReduction = Math.floor(challenges / 100) * (challengeReductionPercent / 100); // Custom % per 100 challenges
    const recognitionReduction = Math.floor(recognitions / 50) * (recognitionReductionPercent / 100); // Custom % per 50 recognitions
    const reportingIncrease = 0.30; // 30% increase in reporting

    // Calculate total reduction percentage
    const totalReduction = challengeReduction + recognitionReduction;
    
    // Calculate savings
    const directSavings = annualCost * totalReduction;
    const reportingImpact = annualCost * reportingIncrease * 0.1; // Assume 10% of reporting increase leads to prevention
    const totalSavings = directSavings + reportingImpact;

    // Update display
    this.savingsAmount.textContent = this.formatCurrency(totalSavings);
    this.savingsText.innerHTML = `
      Based on ${(totalReduction * 100).toFixed(1)}% reduction from program activities
      plus additional savings from ${Math.round(reportingIncrease * 100)}% increased reporting rate.
    `;
  }
} 